var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTop1Bottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "36px",
    viewBox: "0 0 96 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NO.1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.80786903%",
    y1: "41.4994279%",
    x2: "72.478088%",
    y2: "46.46088%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE170",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC532",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.3801638,9.45825448 C67.5968475,12.1311709 62.9430734,13.9817873 61.4188415,15.0101036 C60.6022847,15.5710963 60.4781391,16.0995035 61.0464048,16.5953252 L68.3324953,22.4630977 C69.2055847,23.322469 69.6421294,24.2690377 69.6421294,25.3028038 L69.6421294,32.9262756 C69.8349056,33.7925728 70.4662616,34.1346636 71.5361975,33.9525482 C83.1742238,29.392964 91.3288247,27.2082602 96,27.3984368 L85.3780906,6.64937097 L85.1108045,6.0844612 L75.3801638,9.45825448 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.04964918%",
    y1: "13.8044035%",
    x2: "100%",
    y2: "13.8044035%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF18E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC24",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text-4",
    fontFamily: "FZZYK--GBK1-0, FZZongYi-M05",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 22,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32.6839539,
    y: 13.0142498
  }, "NO.1")), /*#__PURE__*/React.createElement("filter", {
    x: "-14.7%",
    y: "-18.2%",
    width: "129.4%",
    height: "145.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 0.633795892   0 0 0 0 0  0 0 0 0.7 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u6253\\u5F00",
    transform: "translate(-140.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(25.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(115.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NO.1",
    transform: "translate(0.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.683543,9.45825448 C6.90022671,12.1311709 2.24645262,13.9817873 0.722220768,15.0101036 C-0.0943360461,15.5710963 -0.218481627,16.0995035 0.349784027,16.5953252 L7.63587458,22.4630977 C8.50896399,23.322469 8.94550869,24.2690377 8.94550869,25.3028038 L8.94550869,32.9262756 C9.13828484,33.7925728 9.76964088,34.1346636 10.8395768,33.9525482 C22.4776031,29.392964 30.6322039,27.2082602 35.3033792,27.3984368 L24.6814698,6.64937097 L24.4141837,6.0844612 L14.683543,9.45825448 Z",
    id: "\\u8DEF\\u5F84-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84-2",
    transform: "translate(78.348310, 20.042231) scale(-1, 1) translate(-78.348310, -20.042231) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.3362724,3.2148039 C16.1318043,13.1166814 18.4140924,19.9705651 20.1831368,23.7764551 C29.5989925,21.2869721 38.9006457,20.0422306 48.0880964,20.0422306 C59.0028136,20.1839255 68.1334415,21.2960638 75.4799801,23.3786457 C79.4084312,13.6926873 81.6797531,6.97140669 82.2939459,3.2148039 C79.494816,1.85024603 73.0485608,0.899931978 62.9551801,0.363861742 C56.5723461,0.121287247 51.6166516,0 48.0880964,0 C41.1435664,0 36.881994,0.0593521887 35.3033792,0.178056566 C24.2683567,0.406788383 17.0573662,1.2330708 13.6704079,2.65690383 L13.3362724,3.2148039 Z",
    id: "\\u8DEF\\u5F84-3",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0940494,23.7764551 L35.3033792,27.3984368 L32.1533499,21.2243738 C26.269792,22.2456887 22.4599621,23.0521573 20.7238604,23.6437794 L21.0940494,23.7764551 Z",
    id: "\\u8DEF\\u5F84-4",
    fill: "#EAB523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9080517,23.4834234 L75.4799801,27.3984368 L72.2280926,21.0848013 C66.2765464,22.0224087 62.4327225,22.7870236 60.6966208,23.3786457 L60.9080517,23.4834234 Z",
    id: "\\u8DEF\\u5F84-4",
    fill: "#EAB523",
    transform: "translate(68.088300, 24.241619) scale(-1, 1) translate(-68.088300, -24.241619) "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-5)",
    xlinkHref: "#text-4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-4"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop1Bottom);
export default __webpack_public_path__ + "static/media/icon-top1-bottom.659d2939cd57bcb10e5f1668b074ac76.svg";
export { ForwardRef as ReactComponent };